module.exports = __webpack_public_path__ + "img/square.d8b04644.svg";